<template>
  <div class="page">
    <div class="header">
      <div class="header-date">
        <p>{{baseInfo.name}} &nbsp;&nbsp;<span>{{baseInfo.begin_time}}&nbsp;-&nbsp;{{baseInfo.end_time}}</span></p>
        <i
          class="icon iconfont icon-shaixuan header-date-btn "
          @click="onShowDate"
        ></i>
      </div>
      <div class="header-head">
        <img
          :src="baseInfo.avatarPath||url"
          class="header-head-img"
          alt="头像"
        >
        <img
          class="header-head-bg"
          v-if="baseInfo.syntheticRank == 1"
          src="../../assets/img/b1.png"
          alt="第一名"
        >
        <img
          class="header-head-bg"
          v-else-if="baseInfo.syntheticRank == 2"
          src="../../assets/img/b2.png"
          alt="第二名"
        >
        <img
          class="header-head-bg"
          v-else-if="baseInfo.syntheticRank == 3"
          src="../../assets/img/b3.png"
          alt="第三名"
        >
        <span
          class="header-head-card"
          v-else
        >
          {{baseInfo.syntheticRank == 0 || baseInfo.syntheticRank == '-'   ? '暂无排名':`第${baseInfo.syntheticRank}名`}}
        </span>
      </div>
      <div class="header-info">
        <div class="header-info-name">
          <h4>{{baseInfo.name}}</h4>
          {{baseInfo.department}}
        </div>
        <div class="header-info-rank">
          <p>回款排名：<span class="rank">{{baseInfo.rank.back.rank}}</span>
          <img :src="baseInfo.rank.back.change>=0 
          ?upImg:downImg">
           <span class="number">{{baseInfo.rank.back.changeRank}}</span></p>
          <p>签约排名：<span class="rank">{{baseInfo.rank.sign.rank}}</span>
           <img :src="baseInfo.rank.sign.change>=0 
           ?upImg:downImg">
            <span class="number">{{baseInfo.rank.sign.changeRank}}</span></p>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="body-card">
        <h3>计划完成情况(万) <span
            @click="onShowInput"
            v-if="baseInfo.isSelf"
            class="body-card-edit"
          >编辑</span></h3>
        <div class="body-content">
          <div class="body-chart">
            <gauge-chart
              :dataSource="plan.sign"
              title="签约"
            ></gauge-chart>
            <gauge-chart
              :dataSource="plan.back"
              title="回款"
            ></gauge-chart>
            <gauge-chart
              :dataSource="plan.invoice"
              title="开票"
            ></gauge-chart>
            <gauge-chart
              :dataSource="plan.delivery"
              title="交付"
            ></gauge-chart>
          </div>
        </div>
      </div>
      <div class="body-card">
        <h3>待回款情况(万)</h3>
        <div class="body-back">
          <div
            class="body-back-line"
            v-for="(key,index) in waitBackFee"
            :key="index"
          >
            <span class="body-back-name">{{key.title}}(万)</span>
            <span class="body-back-money">{{key.current}} W</span>
            <span class="body-back-per">
              <img :src="key.rate>=0?upImg:downImg" />
              <i>{{key.rate}}</i>%
            </span>
          </div>

        </div>
      </div>
      <div class="body-card">
        <h3>业绩趋势对比</h3>
        <div class="body-content">
          <btn-group
            @click="onClick"
            class="body-content-btn"
          ></btn-group>
          <div class="body-list">
            <div class="body-list-item">
              {{tendency.increaseNum}}
            </div>
            <div class="body-list-item">
              {{tendency.visitorNum}}
            </div>
            <div class="body-list-item">
              {{tendency.signNum}}
            </div>
            <div class="body-list-item">
              {{tendency.invalidNum}}
            </div>
          </div>
          <div class="body-list">
            <div class="body-list-line"><Strong style="color:#5482D2">-</Strong> 新增客户数</div>
            <div class="body-list-line"><Strong style="color:#D185FF">-</Strong> 拜访数</div>
            <div class="body-list-line"><Strong style="color:#86E687">-</Strong> 签约数</div>
            <div class="body-list-line"><Strong style="color:#EC7A8A">-</Strong> 丢单数</div>
          </div>
          <line-chart :dataSource="tendency.line"></line-chart>
        </div>
      </div>
    </div>
    <!-- 弹出时间选择 -->
    <date-right
      v-if="showDate"
      :dateInfo="dateInfo"
      @ok="onDateConfirm"
      @cancel="onHideDate"
    ></date-right>
    <!-- 弹出数据录入 -->
    <input-right
      v-if="showInput"
      :info="baseInfo"
      @ok="onInputConfirm"
      @cancel="onShowInput"
    ></input-right>

  </div>
</template>
<script>
import GaugeChart from './components/gauge'
import LineChart from './components/line'
import BtnGroup from './components/btn'
import DateRight from './components/date-right.vue'
import InputRight from './components/input-right.vue'
import defaultImg from '../../assets/img/user-avatar.png'
import upImg from '../../assets/img/up.png'
import downImg from '../../assets/img/down.png'
import { getCurrentMonth, convertFormat } from '../../assets/js/date'
export default {
  components: {
    GaugeChart,
    LineChart,
    DateRight,
    InputRight,
    BtnGroup
  },
  data() {
    return {
      url: defaultImg,
      showDate: false,
      showInput: false,
      upImg,
      downImg,
      dateInfo: {
        active: {},
        begin_time: getCurrentMonth().begin_time,
        end_time: getCurrentMonth().end_time,
        nameData: []
      },
      tendency: {
        type: 'month',
        increaseNum: 0,
        visitorNum: 0,
        signNum: 0,
        invalidNum: 0,
      },
      baseInfo: {
        name: '',
        begin_time: '',
        end_time: '',
        user_id: '',
        isSelf: false,
        rank: {
          back: {},
          sign: {}
        }
      },
      plan: {
        sign: {
          title: '签约',
          rate: 0,
          real: 0,
          plan: 0,
        },
        back: {
          title: '回款',
          rate: 0,
          real: 0,
          plan: 0,
        },
        invoice: {
          title: '开票',
          rate: 0,
          real: 0,
          plan: 0,
        },
        delivery: {
          title: '交付',
          rate: 0,
          real: 0,
          plan: 0,
        }
      },
      waitBackFee: {
        deliveryWait: {
          title: '已交付待回款',
          current: 0,
          rate: 0
        },
        signWait: {
          title: '已签约待回款',
          current: 0,
          rate: 0
        },
        billWait: {
          title: '已开票待回款',
          current: 0,
          rate: 0
        },
      }
    }
  },

  created() {
    this.baseInfo.begin_time = getCurrentMonth().begin_time
    this.baseInfo.end_time = getCurrentMonth().end_time
    this.initView()
  },
  methods: {
    initView() {
      this.getPerformance()
    },
    getPerformance() {
      this.$http.getPerformanceApi({
        begin_time: convertFormat(this.baseInfo.begin_time),
        end_time: convertFormat(this.baseInfo.end_time),
        user_id: this.baseInfo.user_id,
      }).then(res => {
        this.baseInfo = { ...this.baseInfo, ...res.data }
        this.baseInfo.user_id = this.baseInfo.id
        this.getTendencyfo()
        this.plan = { ...this.plan, ...res.data.plan }
        for (let key in res.data.waitBackFee) {
          if (res.data.waitBackFee.hasOwnProperty(key)) {
            this.waitBackFee[key]['current'] = res.data.waitBackFee[key]['current']
            this.waitBackFee[key]['rate'] = res.data.waitBackFee[key]['rate']
          }
        }
      })
    },
    getTendencyfo() {
      this.$http.getTendencyfoApi({ type: this.tendency.type, user_id: this.baseInfo.user_id }).then(res => {
        this.tendency = { ...this.tendency, ...res.data }
        this.tendency.line = {
          xAxis: res.data.timeZone,
          series: [
            {
              name: '新增客户个数',
              type: 'line',
              data: res.data.increaseArr,
            },
            {
              name: '拜访个数',
              type: 'line',
              data: res.data.visitorArr,
            },
            {
              name: '签约个数',
              type: 'line',
              data: res.data.signArr,
            },
            {
              name: '丢单个数',
              type: 'line',
              data: res.data.invalidArr,
            },
          ]
        }
      })
    },

    getSaleList() {
      this.$http.getSaleListApi().then(res => {
        const temp = []
        Object.keys(res.data).forEach((key, index) => {
          if (key == this.baseInfo.id) {
            this.dateInfo.active = { name: res.data[key], id: key }
          }
          temp.push({ name: res.data[key], id: key })
        })
        this.dateInfo.nameData = temp
        this.showDate = true
      }).catch(err => {
        this.log(err)
      })
    },
    onShowDate() {
      this.getSaleList()
    },
    onHideDate() {
      this.showDate = false
    },
    onShowInput() {
      this.showInput = !this.showInput
    },
    onClick(type) {
      this.tendency.type = type
      this.getTendencyfo()
    },
    onDateConfirm(val) {
      this.baseInfo.begin_time = val.begin_time
      this.baseInfo.end_time = val.end_time
      this.dateInfo.begin_time = val.begin_time
      this.dateInfo.end_time = val.end_time
      this.baseInfo.user_id = val.sale.id
      this.initView()
    },
    onInputConfirm() {
      this.initView()
    }

  }
}
</script>
<style  scoped>
.page {
  width: 100%;
  height: 100%;
}
.header {
  position: relative;
  width: 100;
  height: 7rem;
  background: url("../../assets/img/bg.png") no-repeat;
  background-size: cover;
}
.header-date {
  position: relative;
  width: 100%;
  height: 0.6rem;
  padding: 0.3rem;
  font-size: 14px;
  color: #fff;
}
.header-date-btn {
  position: absolute;
  top: 0.3rem;
  right: 0.1rem;
}
.header-head {
  position: relative;
  width: 2.2rem;
  height: 2.2rem;
  margin: auto;
  margin-top: 2.1rem;
}
.header-head-img {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  border: 2px solid #fff;
}
.header-head-bg {
  position: absolute;
  bottom: -1rem;
  left: -0.4rem;
  width: 3rem;
}
.header-head-card {
  position: absolute;
  left: -0.3rem;
  bottom: -0.7rem;
  display: inline-block;
  width: 2.8rem;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: rgba(224, 32, 225, 1);
  border-radius: 18px;
}
.body-card-edit {
  float: right;
  font-weight: normal;
  margin-right: 4px;
  color: dodgerblue;
}
.header-info {
  position: absolute;
  left: 5%;
  bottom: -1.4rem;
  display: flex;
  width: 90%;
  height: 76px;
  margin: auto;
  margin-top: 1rem;
  background: rgba(22, 53, 205, 0.65);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}
.header-info-name {
  position: relative;
  height: 76px;
  padding: 10px;
  width: 37%;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
}
.header-info-name h4 {
  font-size: 16px;
  color: #fff;
  margin: 0.1rem 0;
}
.header-info-name:after {
  position: absolute;
  content: "";
  right: -0.2rem;
  top: 16px;
  width: 1px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
}
.header-info-rank {
  width: 61%;
  height: 76px;
  text-align: right;
  padding: 10px;
  color: #fff;
}
.header-info-rank .number {
  display: inline-block;
  width: 40px;
  text-align: center;
}
.header-info-rank .rank {
  display: inline-block;
  width: 56px;
  color: #fff;
  text-align: center;
}
.header-info-rank p {
  margin: 0.2rem 0;
}
.header-info-rank img {
  width: 14px;
  vertical-align: middle;
}
.header-info-rank span {
  color: rgba(255, 255, 255, 0.6);
}
.body {
  width: 100;
  min-height: 600px;
  padding-top: 60px;
  padding-bottom: 60px;
  background: linear-gradient(
    178deg,
    rgba(32, 7, 75, 1) 0%,
    rgba(84, 130, 210, 1) 100%
  );
}

.body-card {
  width: 90%;
  min-height: 100px;
  margin: 20px auto;
  background: #fff;
  padding-bottom: 20px;
  border-radius: 2px 2px 0px 0px;
}
.body-card h3 {
  width: 100%;
  height: 46px;
  line-height: 46px;
  padding: 0 6px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  border-bottom: 1px solid #ddd;
}
.body-content {
  position: relative;
  width: 100%;
  height: 270px;
}
.body-content-btn {
  position: absolute;
  top: -38px;
  right: 10px;
}
.body-chart {
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.body-back {
  height: 140px;
}
.body-back-line {
  display: flex;
  height: 50px;
  line-height: 50px;
  color: #666;
  border-bottom: 1px solid #eee;
  justify-content: space-around;
}
.body-back-name {
  font-size: 15px;
}
.body-back-money {
  display: inline-block;
  width: 80px;
  font-size: 15px;
  text-align: center;
  font-weight: bold;
}
.body-back-per {
  color: #999;
  font-size: 14px;
}
.body-back-per i {
  display: inline-block;
  width: 28px;
  text-align: center;
  font-style: normal;
}
.body-back-per img {
  width: 14px;
  vertical-align: middle;
}
.body-list {
  display: flex;
  padding: 10px 14px 16px 14px;
  width: 100%;
  height: 26px;
  justify-content: space-between;
}
.body-list-item {
  margin-right: 10px;
  width: 25%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.body-list-item span {
  display: block;
  margin-top: 4px;
  color: #a6a6a6;
  font-size: 14px;
  font-weight: normal;
}
.body-list-line {
  width: 25%;
  text-align: center;
  font-size: 12px;
  color: #666666;
}
</style>


// WEBPACK FOOTER //
// src/components/performance/index.vue